import { exponentialBackoffFullJitter, raceWithAbort, retryUntilNoException, } from '@lucidlink/tscore';
import { NETWORK_RETRY_ATTEMPTS, NETWORK_RETRY_DEADLINE, NETWORK_RETRY_INITIAL_DELAY, NETWORK_RETRY_MAX_DELAY, } from '../../constants';
import { isRetryableDownloadError } from './is-retryable-download-error';
// The sleeps add up to about 7 minutes at most; with full jitter, typically about half.
const delay = exponentialBackoffFullJitter({
    delay: NETWORK_RETRY_INITIAL_DELAY,
    maxDelay: NETWORK_RETRY_MAX_DELAY,
});
export const withNetworkRetry = async (run, { canRetry = () => true, onRetry, signal }) => {
    signal.throwIfAborted();
    // Composed by hand: `AbortSignal.any` is missing on Safari 17.0 to 17.3, the browserslist baseline.
    const attempt = new AbortController();
    const forwardAbort = () => attempt.abort(signal.reason);
    signal.addEventListener('abort', forwardAbort, { once: true });
    const deadlineTimer = setTimeout(() => attempt.abort(new DOMException('Download request timed out', 'TimeoutError')), NETWORK_RETRY_DEADLINE);
    const attemptSignal = attempt.signal;
    try {
        return await raceWithAbort(retryUntilNoException(() => {
            attemptSignal.throwIfAborted();
            return run();
        }, {
            ...(onRetry && { onRetry }),
            retries: NETWORK_RETRY_ATTEMPTS,
            sleep: delay,
            onError: (error) => !attemptSignal.aborted &&
                isRetryableDownloadError(error) &&
                canRetry(error)
                ? 'retry'
                : 'abort',
        }), attemptSignal);
    }
    finally {
        clearTimeout(deadlineTimer);
        signal.removeEventListener('abort', forwardAbort);
    }
};
